// extracted by mini-css-extract-plugin
export default {"paymentSection":"r--z","disabled":"s--z"};